
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"m16.34 48.35.82-5.4H6.2l6.21-40.22a.55.55 0 0 1 .17-.33.55.55 0 0 0 .32-.17h15.38c5.06 0 8.66 1.15 10.46 3.28a6.43 6.43 0 0 1 1.64 3.1 9.46 9.46 0 0 1 0 4.25v1.31l.81.49A7.2 7.2 0 0 1 43 16a6.76 6.76 0 0 1 1.47 3.11 14.5 14.5 0 0 1-.16 4.58 13.45 13.45 0 0 1-2 5.23 11.5 11.5 0 0 1-2.94 3.27A10.5 10.5 0 0 1 35.31 34a22.3 22.3 0 0 1-5.07.65h-1.15a4 4 0 0 0-2.29.82 2.81 2.81 0 0 0-1.14 2.13l-.16.49-1.5 9.6V48c0 .16 0 .16-.16.16h-.14c0 .19-7.36.19-7.36.19"}}),_c('path',{attrs:{"d":"M42 13.19V14c-2 10.46-9 13.9-17.82 13.9h-4.57a2.13 2.13 0 0 0-2.13 1.8l-2.29 14.56-.65 4.09a1.16 1.16 0 0 0 1.14 1.31h8a1.94 1.94 0 0 0 2-1.64v-.33l1.47-9.48.16-.49a2 2 0 0 1 2-1.64h1.09c7.69 0 13.74-3.1 15.54-12.26.81-3.76.32-7-1.64-9.16a7.9 7.9 0 0 0-2.3-1.47","fill":"#0070e0"}}),_c('path',{attrs:{"d":"M40.05 12.37a2.35 2.35 0 0 0-1-.32c-.33 0-.66-.17-1-.17a30 30 0 0 0-3.93-.32H22.06a1.26 1.26 0 0 0-.82.16 2.09 2.09 0 0 0-1.14 1.47l-2.62 16.19v.49a2.12 2.12 0 0 1 2.13-1.8h4.58c8.83 0 15.7-3.6 17.82-13.9v-1a6.5 6.5 0 0 0-1.63-.65.5.5 0 0 0-.33-.15","fill":"#001c64"}}),_c('path',{attrs:{"d":"M20.1 13.19a2.09 2.09 0 0 1 1.14-1.47 1.5 1.5 0 0 1 .82-.16h12.1a28 28 0 0 1 3.93.32c.32 0 .65.17 1 .17a2.35 2.35 0 0 1 1 .32c.16 0 .33.17.49.17.65.16 1.14.49 1.64.65.65-3.76 0-6.38-2.13-8.83C37.76 1.74 33.67.6 28.28.6H12.9a2.26 2.26 0 0 0-2.12 1.8L4.4 43a1.25 1.25 0 0 0 1.31 1.47h9.48l2.29-15Z"}})])
          )
        }
      }
    